(function () {
	function setAccordionState(button, open) {
		const panelId = button.getAttribute("aria-controls");
		const panel = panelId ? document.getElementById(panelId) : button.closest(".about__accordion-item")?.querySelector(".about__accordion-description");
		button.classList.toggle("active", open);
		button.setAttribute("aria-expanded", open ? "true" : "false");
		if (panel) {
			panel.hidden = !open;
			panel.style.display = open ? "block" : "none";
		}
	}

	function initProductAccordion(root = document) {
		root.querySelectorAll(".about__accordion-title:not([data-accordion-ready])").forEach((button) => {
			button.dataset.accordionReady = "true";
			setAccordionState(button, button.getAttribute("aria-expanded") === "true");
			button.addEventListener("click", () => {
				const willOpen = button.getAttribute("aria-expanded") !== "true";
				const scope = button.closest(".product-section") || document;
				scope.querySelectorAll(".about__accordion-title[aria-expanded='true']").forEach((openButton) => {
					if (openButton !== button) setAccordionState(openButton, false);
				});
				setAccordionState(button, willOpen);
			});
		});
	}

	document.addEventListener("shopify:section:load", (event) => initProductAccordion(event.target));
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => initProductAccordion(), { once: true });
	} else {
		initProductAccordion();
	}
})();
